import { InstructionDetailSection } from 'src/Components/Instructions/InstructionDetails/InstructionDetailSection';
import { AttachmentsViewer } from 'src/Components/Shared/AttachmentsViewer';

import styles from './InstructionDetails.module.scss';
import { Props } from './InstructionDetails.types';

const InstructionDetails = ({ instruction, menu }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.topLine}>
        <div className={styles.title}>{instruction.title}</div>
        {menu}
      </div>

      {instruction.attachment && <AttachmentsViewer attachments={[instruction.attachment]} />}

      {instruction.sections.map((section, index) => (
        <InstructionDetailSection key={section.id} section={section} index={index + 1} />
      ))}
    </div>
  );
};

export default InstructionDetails;
